import { gql } from '@apollo/client';

// Query to get models list
export const GET_MODELS = gql`
  query GetModels {
    modelsList {
      id
      name
      description
      provider
      capabilities
      modelArn
      inferenceType
      inferenceTypesSupported
      inputModalities
      outputModalities
      responseStreamingSupported
      customizationsSupported
    }
  }
`;
